module.exports = __webpack_public_path__ + "static/media/logo126.b75944b0.png";